var quiz = {
    questions: [{
        text: "The radius of an HIV virus is",
        responses: [{
            text: "55 nm",
            index: 'A'
          },
          {
            text: "60 nm",
            index: 'B',
            correct: true
          },
          {
            text: "72 nm",
            index: 'C'
          },
          {
            text: "25 nm ",
            index: 'D'
          }
        ]
      },
      {
        text: "There is a protein that stands at the cross-roads of DNA damage, apoptosis and cancer. It is a tumor suppressor and is called",
        responses: [{
            text: "p53",
            index: 'A',
            correct: true
          },
          {
            text: "p19",
            index: 'B'
          },
          {
            text: "p21",
            index: 'C',
          },
          {
            text: "None of the above",
            index: 'D'
          }
        ]
      },
      {
        text: "If the strength of Dark Energy starts to diminish over time, rather than remaining constant, then our Universe will most likely end up in a",
        responses: [{
            text: "Big Rip",
            index: 'A'
          },
          {
            text: "Big Crunch",
            index: 'B',
            correct: true
          },
          {
            text: "Big Freeze",
            index: 'C'
          },
          {
            text: "State of Continued Oscillation",
            index: 'D'
          }
        ]
      },
      {
        text: "String Theory works at ",
        responses: [{
            text: "Very high energies",
            index: 'A',
            correct: true
          },
          {
            text: "Very low energies",
            index: 'B'
          },
          {
            text: "Moderately low energies",
            index: 'C',
          },
          {
            text: "Zero energy",
            index: 'D'
          }
        ]
      },
      {
        text: "The organic molecule, Benzene, has",
        responses: [{
            text: "Three carbon atoms",
            index: 'A'
          },
          {
            text: "Six carbon atoms",
            index: 'B',
            correct: true
          },
          {
            text: "Eight carbon atoms ",
            index: 'C'
          },
          {
            text: "Twelve carbon atoms",
            index: 'D'
          }
        ]
      }
    ]
  },
  userResponseSkelaton = Array(quiz.questions.length).fill(null);
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: quiz,
      questionIndex: 0,
      userResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 60,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      }
    }
  },
  computed: {

  },
  mounted() {
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime)
  },
  methods: {
    selectOption: function(index) {
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.score()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
    },
    // Return "true" count in userResponses
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizGameComputationalS', false);
      }, 500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameComputationalS', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    }
  },
}